import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import "./Admin.css";

const AdminPageShell = ({ active, title, text, children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle("admin-sidebar-visible", sidebarOpen);
    return () => document.body.classList.remove("admin-sidebar-visible");
  }, [sidebarOpen]);

  useEffect(() => {
    document.body.classList.add("admin-dashboard-active");
    return () => document.body.classList.remove("admin-dashboard-active");
  }, []);

  return (
    <div className={`dashboard admin-dashboard-page ${sidebarOpen ? "user-sidebar-active" : ""}`}>
      <button type="button" className="admin-sidebar-toggle" onClick={() => setSidebarOpen(true)}>
        <span className="la la-bars"></span>
        Admin Menu
      </button>

      <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)}></div>
      <AdminSidebar active={active} onClose={() => setSidebarOpen(false)} />

      <section className="user-dashboard">
        <div className="dashboard-outer">
          <div className="upper-title-box">
            <h3>{title}</h3>
            <div className="text">{text}</div>
          </div>
          {children}
        </div>
      </section>

      <div className="copyright-text">
        <p>Copyright 2026 Epic-Jobs. All Right Reserved.</p>
      </div>
    </div>
  );
};

export default AdminPageShell;
